import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { toast } from 'sonner';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';

const MiCodigoReferidoWidget = () => {
  const navigate = useNavigate();
  const { user, API } = useContext(AuthContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showQR, setShowQR] = useState(false);

  useEffect(() => {
    if (user) {
      loadData();
    }
  }, [user]);

  const loadData = async () => {
    try {
      const response = await axios.get(`${API}/mi-codigo-referido`);
      setData(response.data);
    } catch (error) {
      console.error('Error loading referido data:', error);
    } finally {
      setLoading(false);
    }
  };

  const copyCode = (e) => {
    e.stopPropagation();
    if (data?.codigo_referido) {
      navigator.clipboard.writeText(data.codigo_referido);
      toast.success('¡Código copiado al portapapeles!');
    }
  };

  if (loading) return null;
  if (!data) return null;

  return (
    <div
      onClick={() => setShowQR(!showQR)}
      className="group relative bg-gradient-to-br from-purple-500 via-pink-500 to-red-500 rounded-2xl p-6 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl overflow-hidden h-56"
    >
      {/* Efecto de brillo animado */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
      
      {/* Contenido */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-white px-2">
        {showQR ? (
          /* Vista con QR Code */
          <div className="flex flex-col items-center">
            <div className="bg-white p-3 rounded-xl mb-2">
              <QRCodeSVG 
                value={`https://ibaconnect.info/app?ref=${data.codigo_referido}`}
                size={120}
                level="H"
                includeMargin={false}
              />
            </div>
            <p className="text-xs font-bold drop-shadow-lg">
              {data.codigo_referido}
            </p>
            <button
              onClick={copyCode}
              className="mt-2 text-xs bg-white/20 px-3 py-1 rounded-full hover:bg-white/30 transition-colors"
            >
              <i className="fas fa-copy mr-1"></i>
              Copiar
            </button>
          </div>
        ) : (
          /* Vista normal con stats */
          <>
            {/* Ícono */}
            <div className="mb-2 transform group-hover:scale-110 transition-transform duration-300">
              <i className="fas fa-gift text-4xl drop-shadow-lg" />
            </div>

            {/* Stats */}
            <div className="text-center mb-2">
              <div className="text-3xl font-black drop-shadow-lg">
                {data.referidos_totales}
              </div>
              <div className="text-sm font-semibold drop-shadow">
                {data.referidos_totales === 1 ? 'Referido' : 'Referidos'}
              </div>
            </div>

            {/* Denarios */}
            <div className="text-center mb-2">
              <div className="text-xl font-bold drop-shadow-lg flex items-center justify-center gap-1">
                <i className="fas fa-coins text-yellow-300"></i>
                {data.denarios_ganados}
              </div>
              <div className="text-xs opacity-90">Denarios Ganados</div>
            </div>

            {/* Hint */}
            <div className="mt-2 text-xs opacity-75 group-hover:opacity-100 transition-opacity">
              <i className="fas fa-qrcode mr-1" />
              Click para ver QR
            </div>
          </>
        )}
      </div>

      {/* Efecto de pulso en el fondo */}
      <div className="absolute inset-0 bg-white/10 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
    </div>
  );
};

export default MiCodigoReferidoWidget;
